import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import { ArrowDropDownRounded } from '@mui/icons-material';
import PropTypes from 'prop-types';

const DropdownMenu = props => (
  <Menu
    anchorOrigin={{
      horizontal: 'right',
      vertical: 'bottom',
    }}
    elevation={0}
    transformOrigin={{
      horizontal: 'right',
      vertical: 'top',
    }}
    {...props}
  />
);

const MDropdownMenuButton = ({ variant = 'outlined', icon, children, ...otherProps }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const IconComponent = icon || ArrowDropDownRounded;

  const menuItem = React.Children.map(children, child =>
    React.isValidElement(child)
      ? React.cloneElement(child, {
          onClick: event => {
            if (child.props.onClick) child.props.onClick(event);
            handleClose();
          },
        })
      : child
  );

  return (
    <Box>
      <Button
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        disableElevation
        endIcon={<IconComponent sx={{ height: 24, width: 24 }} />}
        id="demo-customized-button"
        onClick={handleClick}
        sx={{
          '& .MuiButton-endIcon': {
            marginLeft: '0',
            marginRight: '0',
          },
        }}
        variant={variant}
        {...otherProps}
      />
      <DropdownMenu anchorEl={anchorEl} id="demo-customized-menu" onClose={handleClose} open={open}>
        {menuItem}
      </DropdownMenu>
    </Box>
  );
};

MDropdownMenuButton.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.elementType,
  variant: PropTypes.string.isRequired,
};

MDropdownMenuButton.defaultProps = {
  icon: null,
};

export default MDropdownMenuButton;
